import * as helper from './../../../Assets/Js/helper';
import * as Events from './Events';
import Video from './../../../Assets/Js/VideoPlayer';

export default class VideoPlayer {

	constructor(videoElement, soundButton, promoLocation) {
		this.videoElement = videoElement;
		this.videoHandler = new Video(videoElement);
		videoElement.play();
		this.videoHandler.showNativeControls(false);
		this.soundButton = soundButton;
		this.promoLocation = promoLocation;
		this.muted = helper.hasClass(this.soundButton, 'off');
		this.endAction = '';
		this._wideScreen = false;
		this.videoHandler.muted = this.muted;

		// this.videoPlayer.muted(this.options.muted);
		this._resizeVideoJS(); // Initialize the function
		helper.addEventListener(window, 'resize', this._resizeVideoJS.bind(this));
		helper.addEventListener(soundButton, 'click', this._changeMuted.bind(this));
		helper.addEventListener(videoElement, 'ended', function () {
			helper.triggerEvent(window, Events.NEXT_ACTION, {action: this.endAction});
		}.bind(this));
	}

	set wideScreen(wideScreen) {
		this._wideScreen = wideScreen;
	}

	_resizeVideoJS() {
		// Get the parent element's actual width
		let player = this.videoElement,
			leftBox = player.parentNode,
			videoWidth = leftBox.offsetWidth,
			videoHeight;

		videoHeight = leftBox.offsetHeight;
		player.width = videoWidth;
		player.height = videoHeight;
	}

	repeat() {
		this.videoHandler.play();
	}

	nextVideo(video) {
		let src = this.promoLocation + video.src;
		this.endAction = video.action;

		if (this._wideScreen) {
			src = src.replace(/\.mp4/, '_16x9.mp4');
		}

		this._changeVideoSource(src);
	}

	_changeVideoSource(mp4Source) {
		let sources = [
			{type: 'video/mp4', src: mp4Source},
			{type: 'video/webm', src: mp4Source.replace(/\.mp4$/, '.webm')},
			{type: 'video/ogg', src: mp4Source.replace(/\.mp4$/, '.ogg')}
		];

		this.videoHandler.poster = mp4Source.replace(/\.mp4$/, '.jpg');
		this.videoHandler.changeVideo(sources);
	}

	_changeMuted() {
		this.muted = !this.muted;
		this.videoHandler.muted = this.muted;

		if (this.muted) {
			helper.addClass(this.soundButton, 'off');
		} else {
			helper.removeClass(this.soundButton, 'off');
		}
	}
}
